import { AlertTitle, Box, Button, Paper, Stack, Typography } from "@mui/material";

import { AppAlert } from "@/common/components/Alert/AppAlert";
import EntityNotFoundAlert from "@/common/components/AppAlerts/EntityNotFoundAlert";
import ExpiredAlert from "@/common/components/AppAlerts/ExpiredAlert";
import NoDataAlert from "@/common/components/AppAlerts/NoDataAlert";
import NoFilesAlert from "@/common/components/AppAlerts/NoFilesAlert";
import InlineCode from "@/common/components/Code/InlineCode";
import { ConnectionStatusIndicator } from "@/common/components/Connection/ConnectionStatusIndicator";
import AppIcon from "@/common/components/Icons/AppIcon";

export function DevAlerts() {
  return (
    <Paper sx={{ p: 2 }}>
      <Stack spacing={2}>
        <Typography component='div' variant='h2'>
          Alerts
        </Typography>

        <Stack spacing={2}>
          <Typography component='div' variant='h5'>
            <InlineCode>MUI Alerts</InlineCode>
          </Typography>

          <AppAlert variant='standard'>Lorem ipsum dolor.</AppAlert>

          <Stack direction='column' spacing={2}>
            <Typography component='div' variant='h6'>
              Variant
            </Typography>
            <Stack direction='row' spacing={2} alignItems='center'>
              <Stack spacing={2}>
                <AppAlert variant='standard'>This is a standard alert.</AppAlert>

                <AppAlert variant='standard'>
                  <AlertTitle>Success</AlertTitle>
                  This is a standard alert with an encouraging title.
                </AppAlert>
              </Stack>
              <Stack spacing={2}>
                <AppAlert variant='filled'>This is a filled alert.</AppAlert>

                <AppAlert variant='filled'>
                  <AlertTitle>Success</AlertTitle>
                  This is a filled alert with an encouraging title.
                </AppAlert>
              </Stack>
              <Stack spacing={2}>
                <AppAlert variant='outlined'>This is a outlined alert.</AppAlert>

                <AppAlert variant='outlined'>
                  <AlertTitle>Success</AlertTitle>
                  This is a outlined alert with an encouraging title.
                </AppAlert>
              </Stack>
            </Stack>
          </Stack>

          <Stack direction='column' spacing={2}>
            <Typography component='div' variant='h6'>
              Size (custom)
            </Typography>
            <Stack direction='row' spacing={2} alignItems='center'>
              <Stack spacing={2}>
                <AppAlert variant='standard' size='standard'>
                  This is a standard alert.
                </AppAlert>

                <AppAlert variant='standard' size='standard'>
                  <AlertTitle>standard</AlertTitle>
                  This is a standard alert with an encouraging title.
                </AppAlert>
              </Stack>

              <Stack spacing={2}>
                <AppAlert variant='standard' size='small'>
                  This is a small alert.
                </AppAlert>

                <AppAlert variant='standard' size='small'>
                  <AlertTitle>small</AlertTitle>
                  This is a small alert with an encouraging title.
                </AppAlert>
              </Stack>
            </Stack>
          </Stack>

          <Stack spacing={2}>
            <Typography component='div' variant='h6'>
              Severity
            </Typography>
            <Stack direction='row' spacing={2} alignItems='center'>
              <Stack spacing={2}>
                <AppAlert severity='success'>This is a success alert.</AppAlert>

                <AppAlert severity='success'>
                  <AlertTitle>Success</AlertTitle>
                  This is a success alert with an encouraging title.
                </AppAlert>
              </Stack>

              <Stack spacing={2}>
                <AppAlert severity='info'>This is a info alert.</AppAlert>

                <AppAlert severity='info'>
                  <AlertTitle>Info</AlertTitle>
                  This is a info alert with an informative title.
                </AppAlert>
              </Stack>

              <Stack spacing={2}>
                <AppAlert severity='warning'>This is a warning aler.</AppAlert>

                <AppAlert severity='warning'>
                  <AlertTitle>Warning</AlertTitle>
                  This is a warning alert with an cautious title.
                </AppAlert>
              </Stack>

              <Stack spacing={2}>
                <AppAlert severity='error'>This is a error alert.</AppAlert>

                <AppAlert severity='error'>
                  <AlertTitle>Error</AlertTitle>
                  This is a error alert with an scary title.
                </AppAlert>
              </Stack>

              <Stack spacing={2}>
                <AppAlert severity='text'>This is a text alert.</AppAlert>

                <AppAlert severity='text'>
                  <AlertTitle>Text</AlertTitle>
                  This is a text alert with an scary title.
                </AppAlert>
              </Stack>
            </Stack>
          </Stack>

          <Stack spacing={1}>
            <Typography component='div' variant='h6'>
              Actions
            </Typography>

            <Stack spacing={1}>
              <AppAlert severity='warning' onClose={() => {}}>
                This Alert displays the default close icon.
              </AppAlert>
              <AppAlert
                severity='success'
                action={
                  <Button color='inherit' size='small'>
                    UNDO
                  </Button>
                }
              >
                This Alert uses a Button component for its action.
              </AppAlert>
            </Stack>
          </Stack>

          <Stack spacing={1}>
            <Typography component='div' variant='h6'>
              Icons
            </Typography>

            <Stack spacing={1}>
              <AppAlert icon={<AppIcon of='check' fontSize='inherit' />} severity='success'>
                This success Alert has a custom icon.
              </AppAlert>
              <AppAlert icon={false} severity='success'>
                This success Alert has no icon.
              </AppAlert>
              <AppAlert
                iconMapping={{
                  success: <AppIcon of='forceApprove' fontSize='inherit' />,
                }}
              >
                This success Alert uses `iconMapping` to override the default icon.
              </AppAlert>
            </Stack>
          </Stack>

          <Stack spacing={1}>
            <Typography component='div' variant='h6'>
              Multiline
            </Typography>

            <Stack spacing={1}>
              <AppAlert>
                <Box>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Atque voluptate
                  repellendus similique soluta laboriosam sequi harum doloremque commodi facilis
                  cupiditate fugit perferendis doloribus quisquam nulla rem, in ut est hic.
                </Box>
                Lorem ipsum dolor sit, amet consectetur adipisicing elit. In harum, deleniti quod
                eum exercitationem dignissimos quasi unde odio cum sapiente optio deserunt ab quo
                facere eos quia enim, alias quos.
              </AppAlert>

              <AppAlert>
                <AlertTitle>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam officia veritatis
                  impedit quae sapiente deserunt, ex, maiores soluta dignissimos molestiae nihil
                  amet enim commodi eos illum hic nam vel rerum?
                </AlertTitle>
                <Box>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Atque voluptate
                  repellendus similique soluta laboriosam sequi harum doloremque commodi facilis
                  cupiditate fugit perferendis doloribus quisquam nulla rem, in ut est hic.
                </Box>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Atque voluptate
                repellendus similique soluta laboriosam sequi harum doloremque commodi facilis
                cupiditate fugit perferendis doloribus quisquam nulla rem, in ut est hic.
              </AppAlert>
            </Stack>
          </Stack>
        </Stack>

        <Typography component='div' variant='h5'>
          <InlineCode>EntityNotFoundAlert</InlineCode>
        </Typography>
        <Box>
          <EntityNotFoundAlert />
        </Box>

        <Typography component='div' variant='h5'>
          <InlineCode>NoDataAlert</InlineCode>
        </Typography>
        <Box>
          <NoDataAlert />
        </Box>

        <Typography component='div' variant='h5'>
          <InlineCode>NoFilesAlert</InlineCode>
        </Typography>
        <Box>
          <NoFilesAlert />
        </Box>

        <Typography component='div' variant='h5'>
          <InlineCode>ExpiredAlert</InlineCode>
        </Typography>
        <Box>
          <ExpiredAlert />
        </Box>
        <Box>
          <Typography variant='h5'>
            <InlineCode>ConnectionStatusIndicator variant = alert</InlineCode>
          </Typography>
          <Box>
            <Typography variant='h6'>connected = false</Typography>
            <ConnectionStatusIndicator isAlwaysVisible={true} isConnected={false} variant='alert' />
          </Box>
          <Box>
            <Typography variant='h6'>connected = true</Typography>
            <ConnectionStatusIndicator isAlwaysVisible={true} isConnected={true} variant='alert' />
          </Box>
        </Box>
      </Stack>
    </Paper>
  );
}
